import {combineReducers} from 'redux';
import common from './common';
import toaster from './toaster';
import peopleInformation from './peopleInformation';
import learnerTasks from './learnerTasks';
import learnerJWToken from './learnerJWToken';
import newsFeedAPI from './newsFeedAPI';
import welcomeFlowApi from './welcomeFlowApi';
import tmsCourses from './tmsCourses';
import announcements from './announcements';
import jwkPublicKey from './jwkPublicKey';
import {DESTROY_SESSION} from './../constants';
import renewalInformation from './renewalInformation';
import currentCourseDetails from './currentCourseDetails';
import tmsAssignments from './tmsAssignments';
import handoutDetails from './getHandoutDetails';
import tmsLearnerSessions from './tmsLearnerSessions';
import citiesList from './citiesList';
import countriesList from './countriesList'
import customFields from './customFields'
import elevateAssessmentDetails from './elevateAssessmentDetails';
import elevateTestResult from './getElevateTestResult';
import sendOTP from './sendOTP'
import statesList from './statesList'
import updateTimezone from './updateTimezone';
import updatePeopleInformation from './updatePeopleInformation';
import skillsProgress from './skillsProgress';
import reachProgress from './reachProgress';
import testProgress from './testProgress';
import createSessionService from './createSessionService';
import getTMSLearnerAvailablity from './getTMSLearnerAvailablity';
import getTMSCalendarEvents from './getTMSCalendarEvents';
import getLearnerFeedback from './getLearnerFeedback';
import learnerFeedback from './learnerFeedback';
import activityReport from './activityReport';
import putCustomFields from './putCustomFields';
import skillOutcomeSummary from './skillOutcomeSummary';
import currentSoloCourseDetails from './currentSoloCourseDetails';
import learnerProgressDetails from './learnerProgressDetails';
import getLearnerDetails from './getLearnerDetails';
import getTWTSessions from './getTWTSessions';
import getTWTToken from './getTWTToken';
import getOtherTasks from './getOtherTasks';
import twtUserTrackHistory from './twtUnlimited';
import vocabularyContents from "./vocabularyCenter";
import soundsOfEnglish from "./soundsOfEnglish";
import globalCommunityTutorials from "./globalCommunityTutorials";
import cultureCentreCountries from './cultureCentreCoordinates';
import getLearnerProgressDetails from './getLearnerProgressDetails';
import tosSessionInfo from "./userTosSession";
import progressDetails from "./progressDetails"
const appReducer = combineReducers({
    common,
    toaster,
    peopleInformation,
    learnerTasks,
    learnerJWToken,
    newsFeedAPI,
    welcomeFlowApi,
    tmsCourses,
    announcements,
    jwkPublicKey,
    renewalInformation,
    currentCourseDetails,
    tmsAssignments,
    handoutDetails,
    tmsLearnerSessions,
    citiesList,
    countriesList,
    customFields,
    elevateAssessmentDetails,
    elevateTestResult,
    sendOTP,
    statesList,
    updateTimezone,
    updatePeopleInformation,
    skillsProgress,
    reachProgress,
    testProgress,
    learnerFeedback,
    createSessionService,
    getTMSLearnerAvailablity,
    getTMSCalendarEvents,
    getLearnerFeedback,
    activityReport,
    putCustomFields,
    skillOutcomeSummary,
    currentSoloCourseDetails,
    getLearnerDetails,
    getTWTSessions,
    getTWTToken,
    twtUserTrackHistory,
    getOtherTasks,
    vocabularyContents,
    soundsOfEnglish,
    globalCommunityTutorials,
    learnerProgressDetails,
    cultureCentreCountries,
    getLearnerProgressDetails,
    tosSessionInfo,
    progressDetails
})

const rootReducer = (state: any, action: any) => {   
    // Clear all data in redux store to initial.
    if(action.type === DESTROY_SESSION)
       state = undefined;
    
    return appReducer(state, action);
 };

export default rootReducer;
